document.addEventListener('turbolinks:load', async () => {
  window.getShowcaseThumbnail()
})
